import React from "react";
import Modal from "./Modal";

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = "Are you sure?",
  message,
  confirmLabel = "Yes",
  cancelLabel = "No",
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} closeButton={false}>
      <div className="bg-white w-[420px] rounded-xl overflow-hidden">
        <div className="p-6">
          <h4
            className="text-center text-gray-800"
            style={{ fontSize: "18px", lineHeight: "24px" }}
          >
            {title}
          </h4>
          {message && (
            <p className="text-center text-gray-500 mt-2 text-sm">
              {message}
            </p>
          )}
        </div>
        <div className="flex bg-[#61748E] justify-end py-3 pr-4 gap-3">
          <button
            type="button"
            className="px-4 py-2 bg-white text-[#61748E] rounded-full uppercase text-sm font-medium"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded-full uppercase text-sm font-medium"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
